import { render, staticRenderFns } from "./NewsPaper.vue?vue&type=template&id=37171c54&scoped=true"
import script from "./NewsPaper.vue?vue&type=script&lang=js"
export * from "./NewsPaper.vue?vue&type=script&lang=js"
import style0 from "./NewsPaper.vue?vue&type=style&index=0&id=37171c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37171c54",
  null
  
)

export default component.exports